import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class LivePenaltiesModuleDisplayEventModel extends BaseAnalyticsEvent {
  gameId: Number;
  athleteId: Number;
  competitorId: Number;

  constructor(params) {
    super('display', 'live-penalty-popup', 'gamecenter');

    this.gameId = params.gameId;
    this.athleteId = params.athleteId;
    this.competitorId = params.competitorId;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.competitorId = this.competitorId;
    properties.athleteId = this.athleteId;

    return properties;
  }
}